import React, { useState, useEffect } from 'react';
import './ShareModal.css';
import { useShareFavorites } from '../api/favorites';
import { useNotifications } from '../context/NotificationContext';
import { Copy } from 'lucide-react';

interface ShareModalProps {
  isOpen: boolean;
  onClose: () => void;
  favoriteUuid: string;
}

const ShareModal: React.FC<ShareModalProps> = ({ isOpen, onClose, favoriteUuid: favoriteUuid }) => {
  const [copied, setCopied] = useState<string | null>(null);
  const [email, setEmail] = useState('');
  const [emailMessage, setEmailMessage] = useState('');
  const [shareUrl, setShareUrl] = useState<string>('');
  
  const shareFavoritesMutation = useShareFavorites();
  const { showError } = useNotifications();

  useEffect(() => {
    if (isOpen) {
      shareFavoritesMutation.mutate(favoriteUuid, {
        onSuccess: (data) => {
          const url = `${window.location.origin}/favorites/invite/${favoriteUuid}?share_id=${data.share_uuid}`;
          setShareUrl(url);
        },
        onError: (error) => {
          showError('Failed to generate share link. Please try again.', error);
        },
      });
    }
  }, [isOpen]);

  const copyToClipboard = async (text: string, type: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(type);
      setTimeout(() => setCopied(null), 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  const handleEmailShare = () => {
    console.log('handleEmailShare', email, emailMessage, shareUrl);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h2 className="modal-title">Share Your Favorites</h2>

        {/* Direct Link Sharing */}
        <div className="share-section">
          <h3>Direct Link</h3>
          <p>Share a link that others can use to view your favorite camps</p>
          <div className="input-group">
            <input 
              type="text" 
              value={shareUrl || 'Generating link...'} 
              readOnly 
              disabled={!shareUrl}
            />
          </div>
          <button 
            className="btn btn--secondary btn--block"
            onClick={() => copyToClipboard(shareUrl, 'url')}
            disabled={!shareUrl || shareFavoritesMutation.isPending}
          >
            <Copy className="icon icon--sm" />{shareFavoritesMutation.isPending ? 'Loading...' : copied === 'url' ? 'Copied!' : 'Copy Link'}
          </button>
        </div>
        <div className="security-info">
          <p>For added security, only registered users who you have shared the link with can view your favorite camps.</p>
        </div>
        {/* Email Sharing */}
        {/* <div className="share-section">
          <h3>Email Invitation</h3>
          <p>Send an email invitation to view your favorite camps</p>
          <div className="form-group">
                <label htmlFor="email">Share to:</label>
                <input
                type="email"
                placeholder="Enter email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                />
            </div>
            <div className="form-group">
                <label htmlFor="emailMessage">Message:</label>
                <textarea
                id="emailMessage"
                placeholder="Add a personal message (optional)"
                value={emailMessage}
                onChange={(e) => setEmailMessage(e.target.value)}
                rows={3}
                />
            </div>
            <button 
              className="btn btn--primary btn--block"
              onClick={handleEmailShare}
              disabled={!email || !shareUrl}
            >
              Send Email
            </button>
          </div> */}
        </div>
      </div>
  );
};

export default ShareModal;
